// import Switch from 'react-ios-switch';
import { Radio } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import React from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setResolution } from "../../Redux/DownloadSlice/downloadSlice";
import SwitchCustom from "../Switches/Switch";
import type { RootState } from "../../Redux/store";

interface ImageDimensionsProps {
  downloadState: RootState["downloadSlice"];
}

const ImageDimensions: React.FC<ImageDimensionsProps> = ({ downloadState }) => {
  const [selectedValue, setSelectedValue] = React.useState(1600);
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(false);

  const dispatch = useDispatch();

  const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    // checked=true -> "0" (same as GetSettings) so download upscales to original photo size.
    const nextChecked = event.target.checked;
    setChecked(nextChecked);
    dispatch(setResolution(nextChecked ? "0" : String(selectedValue)));
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!checked) {
      const val = parseInt(event.target.value, 10);
      setSelectedValue(val);
      dispatch(setResolution(String(val)));
    }
  };
  useEffect(() => {
    const resStr = String(downloadState?.Resolution ?? "");
    if (resStr === "0") {
      setChecked(true);
      setSelectedValue(1600);
    } else if (resStr === "") {
      setChecked(false);
      setSelectedValue(1600);
    } else {
      const res = parseInt(resStr, 10);
      setChecked(false);
      setSelectedValue(Number.isNaN(res) ? 1600 : res);
    }
  }, [downloadState.Resolution]);
  const controlProps = (item: number) => ({
    checked: !checked && selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": String(item) },
  });
  return (
    <Card className="bg_grey">
      <Card.Header>
        <Col className="p-1 d-flex justify-content-between">
          <Row className="productSans text_15 d-flex justify-content-center align-items-center">
            {t("DownloadImage.Resolution")}
          </Row>
          <Row className="p-0 m-0">
            <FormGroup sx={{ p: 0, m: 0 }}>
              <FormControlLabel
                label=""
                control={
                  <SwitchCustom
                    checked={checked}
                    onChange={handleChangeSwitch}
                    sx={{ p: 0, m: 0 }}
                  />
                }
              />
            </FormGroup>
          </Row>
        </Col>
      </Card.Header>
      <Card.Body className="py-0">
        <Col className="p-1 d-flex justify-content-between align-items-center">
          <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
            {"1600px"}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps(1600)}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>

        <Col className="border-top p-1 d-flex justify-content-between align-items-center">
          <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
            {"1024px"}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps(1024)}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>
        <Col
          className="border-top p-1 d-flex justify-content-between align-items-center"
        >
          <Row className="SF m-0 text_16 d-flex justify-content-center align-items-center">
            {"960px"}
          </Row>
          <Row className="m-0 d-flex justify-content-center align-items-center">
            <Radio
              disabled={checked}
              {...controlProps(960)}
              sx={{
                "&.Mui-checked": {
                  color: "#F35B6A",
                },
              }}
            />
          </Row>
        </Col>
      </Card.Body>
    </Card>
  );
};

export default ImageDimensions;
